import { useMutation } from "@tanstack/react-query";

import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";

export const useEventTracking = () => {
  const mutationFn = useApiRequest({
    method: HttpMethod.Post,
  });

  return useMutation({
    mutationKey: ["event-tracking"],
    mutationFn: ({ event_group_id, type }) =>
      mutationFn({
        url: `/events/${event_group_id}/event`,
        data: { type },
      }),
  });
};
